/**
 * Browser stand-in for Node's `async_hooks`, aliased in for client builds by each app's
 * quasar.config.js — the same trick this repo already uses for type-graphql / @nestjs/graphql.
 *
 * `base/store/storeContext.ts` lazily requires `async_hooks` to scope store state per SSR
 * request. The `process.env.SERVER` guard means the browser never executes that path, but
 * webpack still has to *resolve* the require when bundling for the web, and webpack 4's
 * `node: { async_hooks: 'empty' }` option cannot help: NodeSourcePlugin only handles the
 * builtins in its node-libs-browser map, which predates async_hooks.
 *
 * Nothing here should ever run. The methods are implemented rather than left to throw so a
 * stray call degrades to "no request context" instead of crashing the page.
 */
class AsyncLocalStorage {
  getStore () {
    return void 0
  }

  enterWith () {
    // no-op
  }

  run (store, callback) {
    return callback()
  }
}

module.exports = { AsyncLocalStorage }
